import { Level2Wrapper } from '../common/Level2Wrapper';
import { GenericSubSection } from '../common/GenericSubSection';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';

export const PowerEquipment = () => {
  const { subSections } = useLevel1SectionData('interior_questions');

  return (
    <Level2Wrapper label="Power Equipment Checked">
      {subSections.power_equipment_checked && <GenericSubSection section={subSections.power_equipment_checked} />}
    </Level2Wrapper>
  );
};
